import { useMemo } from 'react';
import { trpc } from '@client-trpc';
import { TemplateType } from '@server/trading-templates/schemas/input.schema';
import { TemplateRow } from './template-grid.types';

type UseTemplateGridRowsProps = {
  templateType: TemplateType;
  allowDefaultToggle: boolean;
};

// Template grids now list standalone snapshots only. There is no dependency analysis or
// active-link tracking, so row shaping is just a projection of the fetched templates.
export const useTemplateGridRows = ({
  templateType,
  allowDefaultToggle
}: UseTemplateGridRowsProps) => {
  const { data: templates = [] } = trpc.tradingTemplates.tradingTemplates.useQuery(
    { templateType }
  );

  const rows = useMemo<TemplateRow[]>(
    () =>
      templates.map(({ id, name, isDefault }) => ({
        id,
        name,
        isDefault: allowDefaultToggle ? isDefault : false
      })),
    [allowDefaultToggle, templates]
  );

  return { rows };
};
